import { WidgetProps } from '@rjsf/utils';
import { ShowAdvancedButton } from '../ShowAdvancedButton';

export const ShowAllButton = (props: WidgetProps) => {
  const { update, showAll, toggleShowAll } = props.formContext || {};
  if (!update) return null;

  return (
    <ShowAdvancedButton
      {...props}
      value={showAll}
      onChange={toggleShowAll}
      options={{ ...props.options, fieldsLabel: 'All Fields' }}
    />
  );
};
